module.exports = __webpack_public_path__ + "img/antes_despues_133.41e46298.png";